export const blockIconsPhotoandimageStraightenNew = (
	<span className='material-symbols-outlined'>straighten</span>
);
